import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Text,
  Card,
  CardHeader
} from '@fluentui/react-components'

import './EnvironmentError.css'

export const EnvironmentError = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <div className='error-container'>
      <Card className='card' size='medium'>
        <CardHeader
          className='card-header'
          image={<img src='projectadvantage-logo.png' className='card-image' />}
          header={<Text className='card-title'>{t('SERVER_ERROR_TITLE')}</Text>}
        />
        <Text className='card-description'>{t('SERVER_ERROR_LINE_1')}<br />{t('SERVER_ERROR_LINE_2')}</Text>
      </Card>
    </div>
  )
}

export default EnvironmentError
